import PropTypes from 'prop-types';
import { useDataProvider, useNotify, useListContext, useTranslate } from 'react-admin';
import { useState } from 'react';
import { Button } from '@mui/material';
import RelationIcon from '@mui/icons-material/Shortcut';

const ExportResource = ({ resource, format, dataTransformer, label }) => {
    const dataProvider = useDataProvider();
    const listContext = useListContext();
    const [loading, setLoading] = useState(false);
    const notify = useNotify();
    const translate = useTranslate();

    const submit = async () => {
        setLoading(true);
        try {
            await dataProvider
                .export(resource, {
                    format,
                    dataTransformer,
                    ...listContext,
                })
                .finally(() => setLoading(false));
        } catch (error) {
            notify(error.message, { type: 'error' });
        }
    };
    const buttonLabel = label || translate('common.export');
    return (
        <Button color='primary' size='small' startIcon={<RelationIcon />} onClick={submit} disabled={loading} aria-label={buttonLabel}>
            {buttonLabel}
        </Button>
    );
};

ExportResource.propTypes = {
    resource: PropTypes.string,
    format: PropTypes.string,
    dataTransformer: PropTypes.string,
    label: PropTypes.string,
};

export default ExportResource;
